import { render, staticRenderFns } from "./TextLayer.vue?vue&type=template&id=8cc5c976&"
import script from "./TextLayer.vue?vue&type=script&lang=js&"
export * from "./TextLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports